import type { Graph, GraphModification } from "@lr-notitia/notitia-engineer/schemas";
import type { Ref } from "vue";
import { useViewsStore } from "../views";
import { useExpertKnowledgeStore } from "../expert-knowledge";

export function newGraph(): Graph {
	const graph: Graph = {
		domainId: "",
		descriptor: {},
		defaultLanguage: "en",
		languages: [],
		archived: false,
		version: "",
		releasedate: 0,
		releasenotes: "",
		changelog: "",
		dependencies: [],
		hash: "",
		nodes: {},
	};
	return graph;
}

export function handleGraphModification(graph: Ref<Graph>, nodes: GraphModification) {
	const viewsStore = useViewsStore();
	const expertKnowledgeStore = useExpertKnowledgeStore();
	const ids = Object.keys(nodes);
	ids.forEach((id) => {
		const node = nodes[id];
		if (!node) delete graph.value.nodes[id];
		else graph.value.nodes[id] = node;

		if (viewsStore.openedViewId) viewsStore.getNodePositions(viewsStore.openedViewId);
		if (expertKnowledgeStore.openedFragmentId)
			expertKnowledgeStore.getNodePositions(expertKnowledgeStore.openedFragmentId);
	});
}
